{
  "CONVERSATION": {
    "SELECT_A_CONVERSATION": "กรุณาเลือกการสนทนาจากด้านซ้าย",
    "CSAT_REPLY_MESSAGE": "กรุณาให้คะแนนการสนทนาในครั้งนี้",
    "404": "ขออภัย ไม่พบข้อมูลการสนทนาของท่าน โปรดลองใหม่อีกครั้ง",
    "SWITCH_VIEW_LAYOUT": "สลับมุมมอง",
    "DASHBOARD_APP_TAB_MESSAGES": "ข้อความทั้งหมด",
    "UNVERIFIED_SESSION": "ข้อมูลระบุตัวตนของผู้ใช้รายนี้ยังไม่ได้รับการยืนยัน",
    "NO_MESSAGE_1": "โอ้ว ไม่นะเหมือนจะไม่มีข้อความจากลูกค้าของคุณในกล่องข้อความ",
    "NO_MESSAGE_2": " เพื่อส่งข้อความไปยังเพจของคุณ!",
    "NO_INBOX_1": "โฮล่า! ดูเหมือนว่าคุณยังไม่ได้เพิ่มกล่องจดหมายเลยนะ",
    "NO_INBOX_2": " ที่จะเริ่มต้น",
    "NO_INBOX_AGENT": "เอ่อโอ้! ดูเหมือนว่าคุณไม่ได้เป็นส่วนหนึ่งของกล่องจดหมายใด ๆ โปรดติดต่อผู้ดูแลระบบของคุณ",
    "SEARCH_MESSAGES": "ค้นหาข้อความในการสนทนา",
    "VIEW_ORIGINAL": "View original",
    "VIEW_TRANSLATED": "View translated",
    "EMPTY_STATE": {
      "CMD_BAR": "to open command menu",
      "KEYBOARD_SHORTCUTS": "to view keyboard shortcuts"
    },
    "SEARCH": {
      "TITLE": "ค้นหาข้อความ",
      "RESULT_TITLE": "ผลการค้นหา",
      "LOADING_MESSAGE": "กำลังโหลดข้อมูล",
      "PLACEHOLDER": "พิมพ์ข้อความที่ต้องการค้นหา",
      "NO_MATCHING_RESULTS": "ไม่พบผลการค้นหา"
    },
    "UNREAD_MESSAGES": "ข้อความที่ยังไม่ได้อ่าน",
    "UNREAD_MESSAGE": "ข้อความที่ยังไม่ได้อ่าน",
    "CLICK_HERE": "กดที่นี้",
    "LOADING_INBOXES": "กำลังโหลดกล่องข้อความ",
    "LOADING_CONVERSATIONS": "กำลังโหลดการสนทนา",
    "CANNOT_REPLY": "คุณไม่สามารถตอบกลับได้เนื่องจาก",
    "24_HOURS_WINDOW": "การจำกัดหน้าต่างข้อความ 24 ชั่วโมง",
    "48_HOURS_WINDOW": "การจำกัดหน้าต่างข้อความ 48 ชั่วโมง",
    "API_HOURS_WINDOW": "You can only reply to this conversation within {hours} hours",
    "NOT_ASSIGNED_TO_YOU": "การสนทนานี้ไม่ได้ถูกมอบหมายให้คุณ ต้องการที่จะจัดการด้วยตัวเองหรือไม่?",
    "ASSIGN_TO_ME": "มอบหมายให้ฉัน",
    "BOT_HANDOFF_MESSAGE": "You are responding to a conversation which is currently handled by an assistant or a bot.",
    "BOT_HANDOFF_ACTION": "Mark open and assign to you",
    "BOT_HANDOFF_REOPEN_ACTION": "Mark conversation open",
    "BOT_HANDOFF_SUCCESS": "Conversation has been handed over to you",
    "BOT_HANDOFF_ERROR": "Failed to take over the conversation. Please try again.",
    "TWILIO_WHATSAPP_CAN_REPLY": "คุณสามารถตอบกลับการสนทนานี้ได้โดยใช้รูปแบบข้อความที่กำหนดเท่านั้น",
    "TWILIO_WHATSAPP_24_HOURS_WINDOW": "การจำกัดหน้าต่างข้อความ 24 ชั่วโมง",
    "OLD_INSTAGRAM_INBOX_REPLY_BANNER": "This Instagram account was migrated to the new Instagram channel inbox. All new messages will show up there. You won’t be able to send messages from this conversation anymore.",
    "INSTAGRAM_RESTRICTION_BANNER": "Instagram is currently restricted. Some messages or actions may be delayed or unavailable while we restore full support.",
    "INSTAGRAM_RESTRICTION_STATUS_LINK": "View status update",
    "REPLYING_TO": "คุณกำลังตอบกลับ:",
    "REMOVE_SELECTION": "ลบตัวเลือก",
    "DOWNLOAD": "ดาวโหลด",
    "UNKNOWN_FILE_TYPE": "Unknown File",
    "SAVE_CONTACT": "Save Contact",
    "NO_CONTENT": "No content to display",
    "SHARED_ATTACHMENT": {
      "CONTACT": "{sender} has shared a contact",
      "LOCATION": "{sender} has shared a location",
      "FILE": "{sender} has shared a file",
      "MEETING": "{sender} has started a meeting"
    },
    "UPLOADING_ATTACHMENTS": "กำลังอัปโหลดไฟล์แนบ",
    "REPLIED_TO_STORY": "Replied to your story",
    "UNSUPPORTED_MESSAGE": "This message is unsupported. You can view this message on the Facebook / Instagram app.",
    "UNSUPPORTED_MESSAGE_FACEBOOK": "This message is unsupported. You can view this message on the Facebook Messenger app.",
    "UNSUPPORTED_MESSAGE_INSTAGRAM": "This message is unsupported. You can view this message on the Instagram app.",
    "UNSUPPORTED_MESSAGE_TIKTOK": "This message is unsupported. You can view this message on the TikTok app.",
    "UNSUPPORTED_MESSAGE_WHATSAPP": "This message is unsupported. You can view this message on the WhatsApp app.",
    "SUCCESS_DELETE_MESSAGE": "ลบข้อความสำเร็จเเล้ว",
    "FAIL_DELETE_MESSSAGE": "ไม่สามารถลบข้อความได้ โปรดลองใหม่อีกครั้ง",
    "NO_RESPONSE": "ไม่มีการตอบกลับ",
    "RESPONSE": "Response",
    "RATING_TITLE": "การประเมิน",
    "FEEDBACK_TITLE": "ผลตอบรับ",
    "REPLY_MESSAGE_NOT_FOUND": "Message not available",
    "CARD": {
      "SHOW_LABELS": "แสดงป้ายกำกับ",
      "HIDE_LABELS": "ซ่อนป้ายกำกับ",
      "LABELS_COUNT": "{count} labels"
    },
    "VOICE_CALL": {
      "INCOMING_CALL": "Incoming call",
      "OUTGOING_CALL": "Outgoing call",
      "CALL_IN_PROGRESS": "Call in progress",
      "NO_ANSWER": "No answer",
      "NO_ANSWER_OUTBOUND_LABEL": "No answer",
      "NO_ANSWER_OUTBOUND_SUBTEXT": "Contact didn't pick up",
      "MISSED_CALL": "Missed call",
      "MISSED_CALL_INBOUND_SUBTEXT": "No agent picked up",
      "MISSED_CALL_DECLINED_BY": "Declined by {agentName}",
      "CALL_ENDED": "Call ended",
      "HANDLED_BY": "Handled by {agentName}",
      "NOT_ANSWERED_YET": "Not answered yet",
      "CALLING": "Calling…",
      "THEY_ANSWERED": "They answered",
      "YOU_ANSWERED": "You answered",
      "AGENT_ANSWERED": "{agentName} answered",
      "JOIN_CALL": "Join call",
      "CALL_BACK": "Call back",
      "TRANSCRIPT_SHOW_MORE": "Show more",
      "TRANSCRIPT_SHOW_LESS": "Show less"
    },
    "HEADER": {
      "RESOLVE_ACTION": "เสร็จสิ้น",
      "REOPEN_ACTION": "เปิดใหม่อีกครั้ง",
      "OPEN_ACTION": "เปิด",
      "MORE_ACTIONS": "More actions",
      "OPEN": "เพิ่มเติม",
      "CLOSE": "ปิด",
      "DETAILS": "รายละเอียด",
      "COPY_ID_SUCCESS": "Conversation ID copied to clipboard",
      "SNOOZED_UNTIL": "Snoozed until",
      "SNOOZED_UNTIL_TOMORROW": "พักการสนทนาจนถึงพรุ่งนี้",
      "SNOOZED_UNTIL_NEXT_WEEK": "พักการสนทนาจนถึงสัปดาห์หน้า",
      "SNOOZED_UNTIL_NEXT_REPLY": "พักการสนทนาจนกว่าจะมีการตอบกลับถัดไป",
      "WHATSAPP_CALL": "Start WhatsApp call",
      "WHATSAPP_CALL_FAILED": "Could not start the WhatsApp call.",
      "VOICE_CALL": "Start call",
      "VOICE_CALL_FAILED": "Could not start the call.",
      "WHATSAPP_CALL_PERMISSION_REQUESTED": "Sent a call permission request to the contact. Try again once they accept.",
      "WHATSAPP_CALL_PERMISSION_PENDING": "Call permission request already sent recently. Try again once the contact accepts.",
      "SLA_STATUS": {
        "FRT": "FRT {status}",
        "NRT": "NRT {status}",
        "RT": "RT {status}",
        "MISSED": "missed",
        "DUE": "due"
      }
    },
    "RESOLVE_DROPDOWN": {
      "MARK_PENDING": "ทำเครื่องหมายว่าอยู่ระหว่างดำเนินการ",
      "SNOOZE_UNTIL": "Snooze",
      "SNOOZE": {
        "TITLE": "พักการสนทนาจนถึง",
        "NEXT_REPLY": "การตอบกลับถัดไป",
        "TOMORROW": "พรุ่งนี้",
        "NEXT_WEEK": "สัปดาห์หน้า"
      }
    },
    "MENTION": {
      "AGENTS": "พนักงาน",
      "TEAMS": "ทีม"
    },
    "CUSTOM_SNOOZE": {
      "TITLE": "พักการสนทนาจนถึง",
      "APPLY": "Snooze",
      "CANCEL": "ยกเลิก"
    },
    "PRIORITY": {
      "TITLE": "Priority",
      "OPTIONS": {
        "NONE": "ไม่มี",
        "URGENT": "Urgent",
        "HIGH": "High",
        "MEDIUM": "Medium",
        "LOW": "Low"
      },
      "CHANGE_PRIORITY": {
        "SELECT_PLACEHOLDER": "ไม่มี",
        "INPUT_PLACEHOLDER": "Select priority",
        "NO_RESULTS": "No results found",
        "SUCCESSFUL": "Changed priority of conversation id {conversationId} to {priority}",
        "FAILED": "Couldn't change priority. Please try again."
      }
    },
    "DELETE_CONVERSATION": {
      "TITLE": "Delete conversation #{conversationId}",
      "DESCRIPTION": "Are you sure you want to delete this conversation?",
      "CONFIRM": "ลบ"
    },
    "CARD_CONTEXT_MENU": {
      "PENDING": "ทำเครื่องหมายว่าอยู่ระหว่างดำเนินการ",
      "RESOLVED": "Mark as resolved",
      "MARK_AS_UNREAD": "Mark as unread",
      "MARK_AS_READ": "Mark as read",
      "REOPEN": "เปิดการสนทนาอีกครั้ง",
      "SNOOZE": {
        "TITLE": "Snooze",
        "NEXT_REPLY": "จนกว่าการตอบกลับถัดไป",
        "TOMORROW": "จนกว่าพรุ่งนี้",
        "NEXT_WEEK": "จนกว่าสัปดาห์หน้า"
      },
      "ASSIGN_AGENT": "มอบหมายให้กับ",
      "ASSIGN_LABEL": "Assign label",
      "AGENTS_LOADING": "Loading agents...",
      "ASSIGN_TEAM": "Assign team",
      "DELETE": "Delete conversation",
      "OPEN_IN_NEW_TAB": "Open in new tab",
      "COPY_LINK": "Copy conversation link",
      "COPY_LINK_SUCCESS": "Conversation link copied to clipboard",
      "API": {
        "AGENT_ASSIGNMENT": {
          "SUCCESFUL": "รหัสการสนทนา {conversationId} ถูกมอบหมายให้กับ {agentName}",
          "FAILED": "Couldn't assign agent. Please try again."
        },
        "LABEL_ASSIGNMENT": {
          "SUCCESFUL": "Assigned label #{labelName} to conversation id {conversationId}",
          "FAILED": "Couldn't assign label. Please try again."
        },
        "LABEL_REMOVAL": {
          "SUCCESFUL": "Removed label #{labelName} from conversation id {conversationId}",
          "FAILED": "Couldn't remove label. Please try again."
        },
        "TEAM_ASSIGNMENT": {
          "SUCCESFUL": "มอบหมายให้ทีม {team} มาดูแลการสนทนารหัส {conversationId}",
          "FAILED": "ไม่สามารถมอบหมายให้กับทีมได้ โปรดลองใหม่อีกครั้ง"
        }
      }
    },
    "FOOTER": {
      "MESSAGE_SIGN_TOOLTIP": "ข้อความลายเซ็น",
      "ENABLE_SIGN_TOOLTIP": "เปิดการใช้ลายเซ็นต์",
      "DISABLE_SIGN_TOOLTIP": "ปิดการใช้ลายเซ็นต์",
      "MSG_INPUT": "Shift + enter สำหรับบรรทัดใหม่ เริ่มต้นด้วย '/' เพื่อเลือกคำตอบสำเร็จรูป",
      "PRIVATE_MSG_INPUT": "Shift + enter สำหรับบรรทัดใหม่ สิ่งนี้จะปรากฏแก่พนักงานเท่านั้น",
      "MESSAGING_RESTRICTED": "You cannot reply to this conversation",
      "MESSAGING_RESTRICTED_WHATSAPP": "You can only reply using a template message due to 24-hour message window restriction",
      "MESSAGING_RESTRICTED_API": "You can only reply using a template message due to message window restriction",
      "MESSAGE_SIGNATURE_NOT_CONFIGURED": "ข้อความลายเซ็นต์ไม่ได้ถูกตั้งค่า โปรดปรับแต่งในหน้าตั้งค่าข้อมูลส่วนตัว",
      "COPILOT_MSG_INPUT": "ให้ Copilot คำสั่งเพิ่มเติม หรือถามอย่างอื่น... กด enter เพื่อส่งข้อความติดตาม",
      "CLICK_HERE": "คลิกที่นี่เพื่ออัปเดต",
      "WHATSAPP_TEMPLATES": "Whatsapp Templates"
    },
    "REPLYBOX": {
      "REPLY": "ตอบ",
      "PRIVATE_NOTE": "โน้ตส่วนตัว",
      "SEND": "ส่ง",
      "CREATE": "เพิ่มโน้ต",
      "INSERT_READ_MORE": "Read more",
      "DISMISS_REPLY": "Dismiss reply",
      "REPLYING_TO": "Replying to:",
      "TIP_EMOJI_ICON": "แสดงตัวเลือกอีโมจิ",
      "TIP_ATTACH_ICON": "เพิ่มไฟล์แนบ",
      "TIP_AUDIORECORDER_ICON": "บันทึกเสียง",
      "TIP_AUDIORECORDER_PERMISSION": "ให้สิทธิ์เข้าถึงการใช้งานเสียง",
      "TIP_AUDIORECORDER_ERROR": "ไม่สามารถเปิดการใช้งานเสียงได้",
      "AUDIO_CONVERSION_FAILED": "Audio conversion failed. Please try again.",
      "DRAG_DROP": "ลากเเละปล่อยที่นี่เพื่อเพิ่ม",
      "IMAGE_UPLOAD_SUCCESS": "Image uploaded successfully",
      "START_AUDIO_RECORDING": "เริ่มบันทึกเสียง",
      "STOP_AUDIO_RECORDING": "หยุดบันทึกเสียง",
      "COPILOT_THINKING": "Copilot กำลังคิด",
      "EMAIL_HEAD": {
        "TO": "TO",
        "ADD_BCC": "เพิ่ม BCC",
        "CC": {
          "LABEL": "CC",
          "PLACEHOLDER": "แยกอีเมลโดยใช้เครื่องหมายคอมม่า",
          "ERROR": "โปรดใส่ที่อยู่อีเมลที่ถูกต้อง"
        },
        "BCC": {
          "LABEL": "BCC",
          "PLACEHOLDER": "แยกอีเมลโดยใช้เครื่องหมายคอมม่า",
          "ERROR": "โปรดกรอกอีเมลที่ถูกต้อง"
        }
      },
      "UNDEFINED_VARIABLES": {
        "TITLE": "Undefined variables",
        "MESSAGE": "You have {undefinedVariablesCount} undefined variables in your message: {undefinedVariables}. Would you like to send the message anyway?",
        "CONFIRM": {
          "YES": "ส่ง",
          "CANCEL": "ยกเลิก"
        }
      },
      "QUOTED_REPLY": {
        "ENABLE_TOOLTIP": "Include quoted email thread",
        "DISABLE_TOOLTIP": "Don't include quoted email thread",
        "REMOVE_PREVIEW": "Remove quoted email thread",
        "COLLAPSE": "Collapse preview",
        "EXPAND": "Expand preview"
      }
    },
    "VISIBLE_TO_AGENTS": "โน้ตส่วนตัว: มีเพียงคุณและทีมเท่านั้นที่มองเห็นได้",
    "CHANGE_STATUS": "สถานะการสนทนามีการเปลี่ยนเเปลง",
    "CHANGE_STATUS_FAILED": "เปลี่ยนสถานะของบทสนทนาไม่สำเร็จ",
    "CHANGE_AGENT": "ผู้ได้รับมอบหมายการสนทนานี้มีการเปลี่ยนแปลง",
    "CHANGE_AGENT_FAILED": "Assignee change failed",
    "ASSIGN_LABEL_SUCCESFUL": "Label assigned successfully",
    "ASSIGN_LABEL_FAILED": "Label assignment failed",
    "CHANGE_TEAM": "เปลี่ยนทีมการสนทนาเเล้ว",
    "SUCCESS_DELETE_CONVERSATION": "Conversation deleted successfully",
    "FAIL_DELETE_CONVERSATION": "Couldn't delete conversation! Try again",
    "FILE_SIZE_LIMIT": "ไฟล์ของคุณมีขนาดเกิน {MAXIMUM_SUPPORTED_FILE_UPLOAD_SIZE} MB",
    "FILE_TYPE_NOT_SUPPORTED": "This {fileName} file type is not supported in this conversation",
    "MESSAGE_ERROR": "ไม่สามารถส่งข้อความนี้ได้ โปรดลองใหม่อีกครั้ง",
    "SENT_BY": "ส่งโดย:",
    "BOT": "บอท",
    "NATIVE_APP": "Native app",
    "NATIVE_APP_ADVISORY": "This message was sent from the native app. Reply from Chatwoot to maintain the message window.",
    "SEND_FAILED": "ไม่สามารถส่งข้อความได้ โปรดลองอีกครั้ง",
    "TRY_AGAIN": "ส่งอีกครั้ง",
    "ASSIGNMENT": {
      "SELECT_AGENT": "เลือกพนักงาน",
      "REMOVE": "ลบออก",
      "ASSIGN": "มอบหมาย"
    },
    "CONTEXT_MENU": {
      "COPY": "คัดลอก",
      "REPLY_TO": "Reply to this message",
      "DELETE": "ลบ",
      "CREATE_A_CANNED_RESPONSE": "เพิ่มไปยังชุดคำตอบสำเร็จรูป",
      "TRANSLATE": "Translate",
      "COPY_PERMALINK": "Copy link to the message",
      "LINK_COPIED": "Message URL copied to the clipboard",
      "DELETE_CONFIRMATION": {
        "TITLE": "Are you sure you want to delete this message?",
        "MESSAGE": "You cannot undo this action",
        "DELETE": "ลบ",
        "CANCEL": "ยกเลิก"
      },
      "REPORT_MESSAGE": {
        "LABEL": "Report message",
        "TITLE": "Report Captain message",
        "DESCRIPTION": "Found an issue with this AI response? Let us know what went wrong and our team will review it to help improve Captain's accuracy.",
        "PROBLEM_TYPE": "Problem type",
        "PROBLEM_TYPE_PLACEHOLDER": "Select a problem type",
        "DESCRIPTION_LABEL": "คำอธิบาย",
        "DESCRIPTION_PLACEHOLDER": "Describe the problem in detail",
        "SUBMIT": "Report",
        "SUCCESS": "Thanks for reporting. Our team will take a look.",
        "ERROR": "Could not report this message. Please try again.",
        "REASONS": {
          "incorrect_information": "Incorrect information",
          "inappropriate_response": "Inappropriate response",
          "incomplete_response": "Incomplete response",
          "outdated_information": "Outdated information",
          "other": "Other"
        }
      }
    },
    "SIDEBAR": {
      "CONTACT": "ผู้ติดต่อ",
      "COPILOT": "Copilot"
    },
    "VOICE_WIDGET": {
      "INCOMING_CALL": "Incoming call",
      "OUTGOING_CALL": "Outgoing call",
      "CALL_IN_PROGRESS": "Call in progress",
      "NOT_ANSWERED_YET": "Not answered yet",
      "HANDLED_IN_ANOTHER_TAB": "Being handled in another tab",
      "REJECT_CALL": "Reject",
      "DISMISS_CALL": "Dismiss",
      "JOIN_CALL": "Join call",
      "END_CALL": "End call",
      "MUTE": "Mute mic",
      "UNMUTE": "Unmute mic",
      "VIEW_CHAT_HISTORY": "View chat history",
      "GO_TO_CONVERSATION": "Go to conversation thread"
    }
  },
  "EMAIL_TRANSCRIPT": {
    "TITLE": "ส่งบันทึกการสนทนา",
    "DESC": "ส่งสำเนาบันทึกการสนทนาไปยังที่อยู่อีเมลที่ระบุ",
    "SUBMIT": "ส่ง",
    "CANCEL": "ยกเลิก",
    "SEND_EMAIL_SUCCESS": "บันทึกการสนทนาได้ถูกส่งเเล้ว",
    "SEND_EMAIL_ERROR": "เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง",
    "SEND_EMAIL_PAYMENT_REQUIRED": "Email transcript is not available on your current plan. Please upgrade to use this feature.",
    "FORM": {
      "SEND_TO_CONTACT": "ส่งบันทึกการสนทนาให้ลูกค้า",
      "SEND_TO_AGENT": "ส่งบันทึกการสนทนาให้พนักงานที่ได้รับมอบหมาย",
      "SEND_TO_OTHER_EMAIL_ADDRESS": "ส่งบันทึกการสนทนาให้ที่อยู่อีเมล์อื่น",
      "EMAIL": {
        "PLACEHOLDER": "กรอกที่อยู่อีเมล์",
        "ERROR": "กรุณากรอกที่อยู่อีเมล์ให้ถูกต้อง"
      }
    }
  },
  "ONBOARDING": {
    "TITLE": "สวัสดี 👋, ยินดีต้อนรับเข้าสู่ {installationName}!",
    "DESCRIPTION": "ขอบคุณสำหรับการสมัคร เราอยากให้คุณได้ใช้งาน {installationName} อย่างเต็มที่ เเละนี่คือสิ่งเล็กน้อยที่คุณสามารถทำได้ใน {installationName} เพื่อประสบการณ์การใช้งานที่ดียิ่งขึ้น",
    "GREETING_MORNING": "👋 Good morning, {name}. Welcome to {installationName}.",
    "GREETING_AFTERNOON": "👋 Good afternoon, {name}. Welcome to {installationName}.",
    "GREETING_EVENING": "👋 Good evening, {name}. Welcome to {installationName}.",
    "READ_LATEST_UPDATES": "อ่านการอัปเดตล่าสุด",
    "ALL_CONVERSATION": {
      "TITLE": "รวมการสนทนาของคุณทั้งหมดในที่เดียว",
      "DESCRIPTION": "ดูการสนทนาทั้งหมดจากลูกค้าของคุณในหน้าเดียว คุณสามารถเลือกดูการสนทนาตามช่องทางที่ส่งข้อความ, ตามป้ายกำกับ หรือตามสถานะของการสนทนาได้",
      "NEW_LINK": "คลิกที่นี่เพื่อสร้างกล่องข้อความ"
    },
    "TEAM_MEMBERS": {
      "TITLE": "เชิญสมาชิกในทีมของคุณ",
      "DESCRIPTION": "ในเมื่อคุณพร้อมจะคุยกับลูกค้าแล้ว ให้เพื่อนร่วมทีมเข้ามาช่วยคุณ คุณสามารถเชิญเพื่อนร่วมทีมได้โดยการเพิ่มอีเมลของเขาลงในรายชื่อพนักงาน",
      "NEW_LINK": "คลิกที่นี่เพื่อเชิญสมาชิกในทีม"
    },
    "LABELS": {
      "TITLE": "จัดกลุ่มการสนทนาด้วยป้ายกำกับ",
      "DESCRIPTION": "การติดป้ายกำกับเป็นวิธีง่ายๆเพื่อจัดกลุ่มการสนทนาของคุณ ลองสร้างป้ายกำกับ เช่น #ต้องการความช่วยเหลือ, #คำถามเรื่องใบเสร็จ หรือป้ายอื่นๆ ที่คุณจะนำมาใช้จัดระเบียบการสนทนาในอนาคต",
      "NEW_LINK": "คลิกที่นี่เพื่อสร้างแท็ก"
    },
    "CANNED_RESPONSES": {
      "TITLE": "Create canned responses",
      "DESCRIPTION": "Pre-written quick reply templates help you quickly respond to a conversation. Agents can type the '/' character followed by the shortcode to insert a response.",
      "NEW_LINK": "Click here to create a canned response"
    }
  },
  "CONVERSATION_SIDEBAR": {
    "ASSIGNEE_LABEL": "พนักงานที่ได้รับมอบหมาย",
    "SELF_ASSIGN": "มอบหมายให้ฉัน",
    "TEAM_LABEL": "ทีมที่ได้รับมอบหมาย",
    "SELECT": {
      "PLACEHOLDER": "ไม่มี"
    },
    "ACCORDION": {
      "CONTACT_DETAILS": "รายละเอียดผู้ติดต่อ",
      "CONVERSATION_ACTIONS": "การดำเนินการสนทนา",
      "CONVERSATION_LABELS": "ป้ายกำกับการสนทนา",
      "CONVERSATION_INFO": "ข้อมูลการสนทนา",
      "CONTACT_NOTES": "Contact Notes",
      "CONTACT_ATTRIBUTES": "แอตทริบิวต์ผู้ติดต่อ",
      "PREVIOUS_CONVERSATION": "การสนทนาก่อนหน้า",
      "MACROS": "คีย์ลัด",
      "LINEAR_ISSUES": "Linked Linear Issues",
      "SHOPIFY_ORDERS": "Shopify Orders",
      "SHARED_FILES": "Attachments"
    },
    "SHARED_FILES": {
      "EMPTY": "No attachments yet",
      "DOWNLOAD": "Download file",
      "DOWNLOAD_ERROR": "Could not download the file. Please try again.",
      "MEDIA_HEADING": "Media",
      "FILES_HEADING": "Files",
      "VIEW_ALL": "View all",
      "SHOW_LESS": "Show less",
      "MORE_COUNT": "+{count}",
      "UNTITLED_FILE": "Untitled file",
      "JUMP_TO_MESSAGE": "Jump to message"
    },
    "SHOPIFY": {
      "ORDER_ID": "Order #{id}",
      "ERROR": "Error loading orders",
      "NO_SHOPIFY_ORDERS": "No orders found",
      "FINANCIAL_STATUS": {
        "PENDING": "กำลังร้องขอ",
        "AUTHORIZED": "Authorized",
        "PARTIALLY_PAID": "Partially Paid",
        "PAID": "Paid",
        "PARTIALLY_REFUNDED": "Partially Refunded",
        "REFUNDED": "Refunded",
        "VOIDED": "Voided"
      },
      "FULFILLMENT_STATUS": {
        "FULFILLED": "Fulfilled",
        "PARTIALLY_FULFILLED": "Partially Fulfilled",
        "UNFULFILLED": "Unfulfilled"
      }
    }
  },
  "CONVERSATION_CUSTOM_ATTRIBUTES": {
    "ADD_BUTTON_TEXT": "สร้างแอตทริบิวต์",
    "NO_RECORDS_FOUND": "ไม่พบข้อมูล",
    "UPDATE": {
      "SUCCESS": "อัปเดตแอตทริบิวต์สำเร็จแล้ว",
      "ERROR": "ไม่สามารถอัปเดตแอตทริบิวต์ได้ โปรดลองใหม่อีกครั้ง"
    },
    "ADD": {
      "TITLE": "เพิ่ม",
      "SUCCESS": "เพิ่มแอตทริบิวต์สำเร็จแล้ว",
      "ERROR": "ไม่สามารถเพิ่มแอตทริบิวต์ได้ โปรดลองใหม่อีกครั้ง"
    },
    "DELETE": {
      "SUCCESS": "ลบแอตทริบิวต์สำเร็จแล้ว",
      "ERROR": "ไม่สามารถลบแอตทริบิวต์ได้ โปรดลองใหม่อีกครั้ง"
    },
    "ATTRIBUTE_SELECT": {
      "TITLE": "เพิ่มแอตทริบิวต์",
      "PLACEHOLDER": "ค้นหาแอตทริบิวต์",
      "NO_RESULT": "ไม่พบแอตทริบิวต์ที่ค้นหา"
    }
  },
  "EMAIL_HEADER": {
    "FROM": "จาก",
    "TO": "ถึง",
    "BCC": "สำเนาลับ",
    "CC": "สำเนา",
    "SUBJECT": "หัวเรื่อง",
    "EXPAND": "Expand email"
  },
  "CONVERSATION_PARTICIPANTS": {
    "SIDEBAR_MENU_TITLE": "Participating",
    "SIDEBAR_TITLE": "Conversation participants",
    "NO_RECORDS_FOUND": "No results found",
    "ADD_PARTICIPANTS": "Select participants",
    "REMANING_PARTICIPANTS_TEXT": "+{count} others",
    "REMANING_PARTICIPANT_TEXT": "+{count} other",
    "TOTAL_PARTICIPANTS_TEXT": "{count} people are participating.",
    "TOTAL_PARTICIPANT_TEXT": "{count} person is participating.",
    "NO_PARTICIPANTS_TEXT": "No one is participating!.",
    "WATCH_CONVERSATION": "Join conversation",
    "YOU_ARE_WATCHING": "You are participating",
    "API": {
      "ERROR_MESSAGE": "Could not update, try again!",
      "SUCCESS_MESSAGE": "Participants updated!"
    }
  },
  "TRANSLATE_MODAL": {
    "TITLE": "View translated content",
    "DESC": "You can view the translated content in each langauge.",
    "ORIGINAL_CONTENT": "Original Content",
    "TRANSLATED_CONTENT": "Translated Content",
    "NO_TRANSLATIONS_AVAILABLE": "No translations are available for this content"
  },
  "TYPING": {
    "ONE": "{user} is typing",
    "TWO": "{user} and {secondUser} are typing",
    "MULTIPLE": "{user} and {count} others are typing"
  },
  "COPILOT": {
    "TRY_THESE_PROMPTS": "Try these prompts"
  },
  "GALLERY_VIEW": {
    "ERROR_DOWNLOADING": "Unable to download attachment. Please try again"
  }
}
